export default class NavbarSkeleton {
    constructor() {
        // Used to make the skeleton bar disapear when the real navbar is loaded
        document.addEventListener("navbar_loaded", function () {
            for (const navbar of document.getElementsByClassName('navbar-skeleton')) {
                navbar.style.display = 'none';
            }
        });
    }
}
